import {
  Box,
} from "@mui/material";
import { Form, Formik } from "formik";
import FormikControl from "components/wrapperComponents/FormikControl";
import React, { useState, useEffect, useRef } from "react";
import "./NewsAnnouncements.scss";
import { msgTypes } from "constants/msgTypes";
import { styled } from "@mui/material/styles";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { PaginatorModel } from "model/utilModels/PaginatorModel";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { AnnouncementModel } from "model/screensModels/AnnouncementModel";
import { AnnouncementService } from "services/menu/announcementService/AnnouncementService";
import { AnnouncementSchema } from "schemas/menu/announcement/AnnouncementSchema";
import { LocalStorageService } from "services/auth/LocalStorageService";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  whiteSpace: "nowrap",
  width: 1,
});



const CreateNewsAnnouncements = ({ setFlag, updateRecord, loadRecentAnnouncement }) => {
  const [viewMode, setViewMode] = useState(false);
 
  const formikRef = useRef(null);
  const fileInputRef = useRef(null);

  const [initialValues, setInitialValues] = useState(
    new AnnouncementModel()
  );

  const paginatorModel = new PaginatorModel();
  const [pagination, setPagination] = useState({
    pageSize: paginatorModel.pageSize,
    pageNumber: paginatorModel.pageNumber,
  });

  const onSubmit = async (values: AnnouncementModel) => {
    addAnnouncement(values)
  }

  useEffect(() => {
    if (updateRecord) {
      setInitialValues(updateRecord)
    }
  }, [updateRecord])

  const prepareRequestBody = async (values: AnnouncementModel) => {
    const prepareData = new AnnouncementModel();
    if (values.announcementId != "" && values.announcementId != undefined) {
      prepareData.announcementId = values.announcementId;
    }
    prepareData.title = values.title ? values.title : '';
    prepareData.message = values.message ? values.message : '';
    prepareData.attachment = values.attachment ? values.attachment : "";
    prepareData.status = values.status ? values.status : false;

     //get Company Id
     const userDetails = await LocalStorageService.getUserDetails();
     if (userDetails !== '') {
       const companyDetails = JSON.parse(userDetails)
       prepareData.companyId = companyDetails.companyId;
     }

    return prepareData;
  }

  const addAnnouncement = async (values: AnnouncementModel) => {
    const requestData = await prepareRequestBody(values);
    const res = await AnnouncementService.saveAnnouncement(requestData);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setInitialValues(new AnnouncementModel())
      loadRecentAnnouncement();
      formikRef.current.resetForm();
      formikRef.current.setFieldValue('imageFile', null);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  }


  return (
    <>
      <div className="sub-content-sec recently-blog">
        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          validationSchema={AnnouncementSchema}
          onSubmit={onSubmit}
          innerRef={formikRef}

        >
          {({ dirty, isValid, values }) => (
            <Form>
              <Box className="form-box bg-white">
                <div className="row p-3">
                  <div className="col-md-12 position-relative">
                    <FormikControl
                      control="textfield"
                      name="title"
                      label="Title"
                      placeholder="Enter Title"
                      requiredField
                      disabled={viewMode}
                    />
                  </div>

                  <div className="col-md-12 position-relative">
                    <FormikControl
                      control="textfield"
                      name="message"
                      label="Message"
                      placeholder="Write Message"
                      requiredField
                      multiline
                      rows={8}
                      disabled={viewMode}
                    />
                  </div>

                  <div className="col-md-6 position-relative">
                    <FormikControl
                      control="uploadImage"
                      name="attachmentFile"
                      label="Attachment"
                      nameUrl="attachment"
                      requiredField
                      disabled={viewMode}
                      inputRef={fileInputRef}
                    />
                  </div>
                  <div className="col-12 d-flex justify-content-end">
                    <FormikControl
                      control="button"
                      className="btn-submit btn"
                      color="primary"
                      label={
                        values.announcementId === "" ? "Save" : "Update"
                      }
                      type="submit"
                      disabled={!dirty || !isValid}
                    />&nbsp;&nbsp;
                    <FormikControl
                      control="button"
                      className="btn-cancel btn"
                      color="warning"
                      label="Back"
                      type="reset"
                      onClick={() => {
                        setFlag(false);
                      }}
                    />
                  </div>
                </div>
              </Box>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default CreateNewsAnnouncements;
